import {
  Field,
  Link,
  LinkField,
  Text,
} from "@sitecore-jss/sitecore-jss-nextjs";
import clsx from "clsx";
import { SierraAgent } from "@repo/sierra-chat";
import { ComponentProps } from "@repo/sitecore-lib/component-props";
import { Button } from "@repo/ui/button";
import * as Flex from "@repo/ui/flex";
import { useChatbotContext } from "../../../providers/chatbot-provider";
import { isMobile } from "../../../utils";
import styles from "./get-in-touch.module.css";

type ActionButtonsProps = ComponentProps & {
  fields: {
    data: {
      contextItem: {
        chatOnlineButton: Field<string>;
        myAccountButton: Field<string>;
        myAccountLink: LinkField;
      };
    };
  };
};

const ActionButtons = ({
  fields: {
    data: {
      contextItem: { myAccountButton, myAccountLink },
    },
  },
}: ActionButtonsProps) => {
  const mobile = isMobile();

  const { handleChatBotStatusChange, isChatbotActive } = useChatbotContext();

  return (
    <Flex.Container
      className={styles.actionButtonContainer}
      column={!!mobile}
      gap="lg"
    >
      {!isChatbotActive && (
        <Button
          className={clsx("typographyLabel3", styles.actionButton)}
          size="large"
          variant="primary"
          alignment="start"
          asChild
        >
          <Link field={myAccountLink || ""}>
            <Text field={myAccountButton} />
          </Link>
        </Button>
      )}
      <SierraAgent handleChatBotStatusChange={handleChatBotStatusChange} />
    </Flex.Container>
  );
};

export default ActionButtons;
